<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px;"
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickRefreshClubs()"
                >
                    <v-list-item-title>Refresh clubs from {{crm_name}}...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <div
        v-if="add_to_bulk_message != null"
        style="margin-bottom: 15px; display: flex"
    >
        <div
            style="flex-grow: 1"
        >
            <v-chip
                v-for="(item, index) in selected_clubs"
                :key="'st_'+index"
                style="margin-right: 5px; margin-bottom: 5px"
                close
                v-on:click:close="onClickClose(item)"
            >
                {{item.text}}
            </v-chip>
        </div>
        <div
            style="flex-grow: 0"
        >
            <v-btn
                :disabled="selected_clubs.length == 0"
                v-on:click="onClickAddCustomersToBulkMessage"
            >
                Add Customers to Bulk Message...
            </v-btn>
        </div>
    </div>


    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.selected="{ item }">
            <v-simple-checkbox
                :value="isSelected(item)"
                v-on:input="onChangeSelected($event, item)"
            />
        </template>

    

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickViewInCrm(item)"
                    v-if="item.url_view_in_crm != null"
                >
                    <v-list-item-title>View in {{crm_name}}...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalData(item)"
                >
                    <v-list-item-title>Technical Details...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickTechnicalDataRaw(item)"
                >
                    <v-list-item-title>Technical Details (raw data sent by {{crm_name}})...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>
    
    </v-data-table>

    

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {

    data() {
        return {
            full_text: null,
            results: [],

            add_to_bulk_message: null,
            selected_clubs: [],
        }
    },


    mounted () {
        this.updateAddToBulkMessage();
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/integrations/crm/club-meta-data',
            
                {
                    'full_text': this.full_text,
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search clubs');
                },
            );
        },

        updateAddToBulkMessage()
        {
            if ( this.$route.query.add_to_bulk_message_id == null )
            {
                this.add_to_bulk_message = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/bulk/messages/get-profile/:bulk_message_id',
            
                'params' : {
                        'bulk_message_id': this.$route.query.add_to_bulk_message_id,
                    },
            
                'on_success': (data) => {
                        this.add_to_bulk_message = data;
                    },
            
                'on_error': 'Unable to get bulk message meta data',
            });
        },

        onClickViewInCrm(item)
        {
            window.open(item.url_view_in_crm,"_blank");
        },

        onClickTechnicalData(item)
        {
            this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': item,
                });
        },

        onClickTechnicalDataRaw(item)
        {
            try {
                let object = JSON.parse(item.raw_content);

                this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'object': object,
                });
            } 
            catch (e) 
            {
                this.$rc.copy_code_dialog({
                    'title': 'Technical Details',
                    'code': item.raw_content,
                });
            }
        },

        onClickRefreshClubs()
        {
            this.$rc.startProcess({
                'type': 'crm-sync-club-meta-data',

                'params': {
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                },
            
                'title': 'Refreshing clubs from '+this.crm_name,
                'finished_button_text': 'Ok',
                'failed_button_text': 'Ok',
            
                status: (pte) => {
                    if ( pte.state == 'failed' )
                        return "Club regresh failed";

                    return 'Club meta data downloaded: '+pte.progress_counter;
                },
            
                on_finished: (pte) => {
                    this.doUpdate();
                },
            
                on_failed: (pte) => {
                    this.doUpdate();
                },
            
            });
        },

        onChangeSelected(val, item)
        {
            this.selected_clubs = this.selected_clubs.filter((el) => el.value != item.club_id);

            if ( val == false )
            {    
                return;
            }

            this.selected_clubs.push({
                'text': item.label,
                'value': item.club_id,
            });

            this.$forceUpdate();
        },

        onClickClose(item)
        {
            this.selected_clubs = this.selected_clubs.filter((el) => el.value != item.value);
            this.$forceUpdate();
        },

        isSelected(item)
        {
             return this.selected_clubs.some((el) => el.value == item.club_id);
        },

        onClickAddCustomersToBulkMessage()
        {
            this.$rc.confirm({
                'title': 'Warning: Check your recipients carefully',
                'body': '<p>RedChirp does its best to create an accurate and complete list of customers with active subscriptions to <b>any</b> of club(s) you have specified.  Despire our best efforts, however, such a list may be inaccurate or incomplete.</p><p>It is important that you check your recipients <b>very carefully</b> before sending any bulk message.</p>',
                'btn_text_ok': 'I understand',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doAddCustomersToBulkmessage();
                },
            });
        },

        doAddCustomersToBulkmessage()
        {
            this.$rc.startProcess({
                'type': 'crm-create-excel-preview-of-customers-with-active-club-membership-for-bulk-message',
            
                'params': {
                    'organization_id' : this.$route.params.organization_id,
                    'content_type' : this.$route.params.content_type,
                    'bulk_message_id': this.add_to_bulk_message.bulk_message_id,
                    'club_ids': this.selected_clubs.map(el => el.value),
                },
            
                'title': 'Listing customers with active club memberships',
                'finished_button_text': 'Preview Recipients',
                'failed_button_text': 'Cancel',
            
                status: (pte) => {
                    return 'Customer phone numbers: '+pte.progress_counter;
                },
            
                on_finished: (pte) => {
                    this.$router.push({
                        'name': 'bulk-recipient-preview',
                        'params' : {
                            'organization_id' : pte.output.organization_id,
                            'bulk_message_id' : pte.output.bulk_message_id,
                            'import_id' : pte.output.import_id
                        }
                    });
                },
            
                on_failed: (pte) => {
                },
            
            });
        },
    
    },

    computed: {
        title() {
            if ( this.add_to_bulk_message != null )
            {
                return "Add customers with "+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+" active club membership to bulk message \""+this.add_to_bulk_message.label+"\"";
            }

            return 'Search '+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+' Clubs';
        },

        crm_name() {
            return this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name');
        },

        headers() {
            let ret = [];

            if ( this.add_to_bulk_message != null )
            {
                ret.push({ text: 'Selected', value: 'selected'});
            }
            
            return ret.concat(
                [
                    { text: 'Club', value: 'label'},
                    { text: 'Action', value: 'action'},
                ]
            );
        }
    },
}
</script>

<style lang="scss" scoped>
</style>